import { PartialTranslation } from '../translations';

export const it: PartialTranslation = {
  newChat: 'Nuova Chat',
  search: 'Cerca',
  user: 'Utente',
  settings: 'Impostazioni',
  language: 'Lingua',
  getHelp: 'Ottieni aiuto',
  viewAllPlans: 'Visualizza tutti i piani',
  learnMore: 'Scopri di più',
  logOut: 'Disconnetti',
  chooseLanguage: 'Scegli Lingua',
  chooseYourPreferredLanguage: 'Scegli la tua lingua preferita',
  searchLanguages: 'Cerca lingue...',
  autoDetect: 'Rilevamento automatico',
  noLanguagesFound: 'Nessuna lingua trovata',
  askAnything: 'Chiedi qualsiasi cosa',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Personale',
  freePlan: 'Piano gratuito',
  current: 'Attuale',
  close: 'Chiudi',
  archive: 'Archivia',
  delete: 'Elimina',
  confirmDelete: 'Sei sicuro di voler eliminare questa chat?',
  confirmArchive: 'Sei sicuro di voler archiviare questa chat?',
  deleteCannotUndo: 'Questa azione non può essere annullata.',
  archiveCanFind: 'Puoi trovarla nell\'elenco degli archivi dopo l\'archiviazione.',
  
  // 资源面板
  resources: 'Risorse',
  addResource: 'Aggiungi risorsa',
  deleteResource: 'Elimina risorsa',
  noMatchingResourcesFound: 'Nessuna risorsa corrispondente trovata',
  noResourcesAvailable: 'Nessuna risorsa disponibile',
  hideResources: 'Nascondi risorse',
  showResources: 'Mostra risorse',
  
  // 聊天输入框
  typeMessage: 'Digita un messaggio...',
  thinkingOptions: 'Opzioni di pensiero',
  deleteFile: 'Elimina file',
  clearSelection: 'Cancella selezione',
  addAttachment: 'Aggiungi allegato',
  sendMessage: 'Invia messaggio',
  
  // 思考模式选项
  deepInsight: 'Intuizione Profonda · Analisi Superficiale',
  deepInsightDesc: 'Comprensione rapida dei punti chiave',
  deepExploration: 'Esplorazione Profonda · Analisi Completa',
  deepExplorationDesc: 'Ricerca approfondita multidimensionale',
  deepDeconstruction: 'Decostruzione Profonda · Argomentazione Sistematica',
  deepDeconstructionDesc: 'Analisi progressiva strato per strato',
  
  // 写作模式选项
  contractReview: 'Revisione Contratto · Identificazione Rischi',
  contractReviewDesc: 'Analisi clausole e controllo conformità',
  textPolish: 'Rifinitura Testo · Espressione Professionale',
  textPolishDesc: 'Ottimizzazione linguistica e aggiustamento strutturale',
  legalDocuments: 'Documenti Legali · Bozza Standard',
  legalDocumentsDesc: 'Scrittura professionale di documenti legali',

  // 认证和隐私翻译
  login: 'Accedi',
  register: 'Registrati',
  welcomeBack: 'Benvenuto su LawHelper',
  loginSubtitle: 'Il Tuo Assistente IA per la Ricerca Legale',
  continueWithGoogle: 'Continua con Google',
  continueWithMicrosoft: 'Continua con Microsoft',
  continueWithWeChat: 'Continua con WeChat',
  orContinueWith: 'o continua con',
  emailTab: 'Email',
  phoneTab: 'Telefono',
  emailPlaceholder: 'Inserisci la tua email',
  phonePlaceholder: 'Inserisci il numero di telefono',
  codePlaceholder: 'Inserisci il codice a 6 cifre',
  sending: 'Invio in corso...',
  verifying: 'Verifica in corso...',
  verify: 'Verifica',
  sendMagicLink: 'Invia link magico',
  getVerificationCode: 'Ottieni codice',
  resendCode: 'Reinvia codice',
  resendIn: 'Reinvia tra',
  magicLinkSent: 'Link magico inviato alla tua email',
  magicLinkHint: 'Invieremo un link sicuro alla tua email',
  otpSent: 'Codice di verifica inviato',
  agreeToTerms: 'Continuando, accetti i nostri',
  privacyPolicy: 'Informativa sulla Privacy',
  termsOfService: 'Termini di Servizio',
  and: 'e',
  privacyTitle: 'La tua privacy è importante',
  privacyIntro: 'Utilizziamo cookie e tecnologie simili per offrirti la migliore esperienza.',
  essentialCookies: 'Cookie essenziali',
  essentialDesc: 'Necessari per il funzionamento del sito',
  analyticsCookies: 'Cookie analitici',
  analyticsDesc: 'Ci aiutano a migliorare il servizio',
  marketingCookies: 'Cookie di marketing',
  marketingDesc: 'Utilizzati per contenuti personalizzati',
  acceptAll: 'Accetta tutto',
  essentialOnly: 'Solo essenziali',
  customize: 'Personalizza',
  savePreferences: 'Salva preferenze',
  back: 'Indietro',
  readPrivacyPolicy: 'Leggi la nostra informativa sulla privacy',
  cookiePolicy: 'Politica dei cookie',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'Revisione IA',
  aiDraft: 'Bozza IA',
  smartAssistant: 'Modello',

  // 知识库搜索
  enableKnowledgeSearch: 'Attiva ricerca',
  knowledgeSearchDesc: 'IA cerca nei tuoi documenti',
  clickToDisable: 'Disattiva',
  clickToEnable: 'Attiva',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Chiudi pannello risorse',
  uploading: 'Caricamento di %{fileName}...',
  processing: 'Elaborazione di %{fileName}...',
  uploadSuccess: '✓ %{fileName} caricato con successo',
  uploadError: '✗ Caricamento fallito: %{error}',
  quickAnswer: 'Risposta rapida',
  quickAnswerDesc: 'Risposta veloce per domande semplici',
  cancelRequest: 'Annulla',
  library: 'Libreria',
  filterAll: 'Tutto',
  filterChat: 'Chat',
  filterReview: 'Revisione',
  filterDraft: 'Bozza',
  filterTemplate: 'Modello',
  filterForm: 'Modulo',
  thinking: 'Sto pensando...',
  thinkingProcess: 'Processo di pensiero',
  analyzingLegalLogic: 'Analisi della logica giuridica...',
  lawhelperThinking: 'Lawhelper sta pensando...',
  serviceError: 'Errore del servizio',
  uploaded: 'Caricato',
  settingsGeneral: 'Generale',
  settingsNotifications: 'Notifiche',
  settingsAppearance: 'Aspetto',
  settingsProfile: 'Profilo',
  settingsResponseNotifications: 'Notifiche di risposta',
  settingsResponseNotificationsDesc: 'Notifica al completamento della risposta IA',
  settingsColorMode: 'Modalità colore',
  settingsLight: 'Chiaro',
  settingsDark: 'Scuro',
  settingsSystem: 'Sistema',
  about: 'Informazioni',
  reviewTitle: 'Revisione documento',
  exitReview: 'Esci dalla revisione',
  uploadPrompt: 'Carica un PDF per iniziare la revisione',
  uploadButton: 'Seleziona file',
  startChatConfig: 'Digita "Rivedi questo documento" per iniziare',
  reviewPlaceholder: 'Digita un messaggio o "Rivedi questo documento"...',
  analyzing: 'Revisione in corso...',
  reviewComplete: 'Revisione completata',
  issuesFound: '%{count} problemi trovati',
  draftTitle: 'Redazione documento legale',
  draftPlaceholder: 'Modifica qui o chiedi all\\\'IA di generare...',
  analyzingTemplate: 'Analisi del modello %{name}...',
  templateAnalyzed: '✅ Modello %{name} analizzato! Indicami come modificarlo.',
  templateAnalysisPrompt: 'Analizzare le clausole chiave del modello',
  parsingFailed: '⚠️ Impossibile analizzare il file, ma puoi descrivere le tue esigenze.',
  generating: 'Generazione in corso...',
  generatedSuccess: '✅ Documento generato! Visualizza e modifica nell\\\'editor.',
  drafterWelcome: 'Benvenuto nell\\\'Assistente IA per Documenti',
  drafterYouCan: 'Puoi:',
  drafterUploadTemplate: 'Caricare un modello per analisi IA',
  drafterDescribeNeeds: 'Descrivere i requisiti del documento',
  drafterLetAiHelp: 'L\\\'IA ti aiuta a redigere contratti, accordi, ecc.',
  drafterExamples: 'Esempi:',
  drafterExampleRental: '"Redigi un contratto di locazione"',
  drafterExampleLabor: '"Compila il contratto di lavoro secondo il modello"',
  drafterInputPlaceholder: 'Descrivi le tue esigenze documentali...',
  drafterThinking: 'Sto pensando...',
  drafterHistoryTitle: 'Cronologia',
  drafterNoHistory: 'Nessuna cronologia',
  drafterNewChat: 'Nuova chat',
  drafterHistory: 'Cronologia',
  drafterRemoveAttachment: 'Rimuovi allegato',
  drafterLineHeight: 'Interlinea',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Esporta come Word (.docx)',
  drafterExportPdf: 'Esporta come PDF',
  drafterSave: 'Salva documento',
  drafterDownload: 'Scarica documento',
  drafterUndo: 'Annulla',
  drafterRedo: 'Ripeti',
  drafterBold: 'Grassetto',
  drafterItalic: 'Corsivo',
  drafterStrike: 'Barrato',
  drafterUnderline: 'Sottolineato',
  drafterHighlight: 'Evidenzia',
  drafterLink: 'Inserisci link',
  drafterAlignLeft: 'Allinea a sinistra',
  drafterAlignCenter: 'Centra',
  drafterAlignRight: 'Allinea a destra',
  drafterAlignJustify: 'Giustifica',
  drafterList: 'Elenco',
  drafterBulletList: 'Elenco puntato',
  drafterOrderedList: 'Elenco numerato',
  drafterTaskList: 'Elenco attività',
  drafterOpenResource: 'Apri pannello risorse',
  drafterStopGeneration: 'Ferma generazione',
  drafterAgentMode: 'Modalità Agente attiva | Clicca per chat normale',
  drafterAgentModeOn: 'Modalità Agente attiva | Clicca per chat normale',
  drafterAgentModeOff: 'Modalità chat normale | Clicca per modalità Agente',
  drafterUploadAttachment: 'Carica allegato',
  drafterExit: 'Esci',
  drafterConfirm: 'Conferma',
  drafterOpenLink: 'Apri link',
  drafterDeleteLink: 'Elimina link',
  drafterQuote: 'Citazione',
  workflowTitle: 'Workflow IA',
  workflowRunning: 'In esecuzione...',
  workflowReady: 'Pronto',
  workflowCompleted: 'Completato',
  workflowStartFailed: 'Avvio workflow fallito',
  workflowExecutionFailed: 'Esecuzione workflow fallita',
  workflowInterrupted: 'Workflow interrotto',
  workflowProcessing: 'Elaborazione...',
  workflowStepsCompleted: 'passaggi completati',
  workflowStepsTotal: 'Workflow completato (%{count} passaggi)',
  acceptChanges: 'Accetta modifiche',
  rejectChanges: 'Rifiuta modifiche',
  changesAccepted: 'Modifiche accettate',
  changesRejected: 'Modifiche rifiutate',
  stopWorkflow: 'Ferma',
  restartWorkflow: 'Riavvia',
  startDrafting: 'Inizia redazione',
  interrupt: 'Ferma',
  documentSubject: 'Oggetto del documento *',
  documentType: 'Tipo di documento',
  jurisdiction: 'Giurisdizione',
  specialRequirements: 'Requisiti speciali (opzionale)',
  clickStartDrafting: 'Clicca "Inizia redazione" per avviare il workflow',
  docTypeContract: 'Contratto',
  docTypeAgreement: 'Accordo',
  docTypeNotice: 'Avviso',
  docTypeLetter: 'Lettera',
  docTypePetition: 'Petizione',
  docTypeWill: 'Testamento',
  docTypePowerOfAttorney: 'Procura',
  countryChina: 'Cina',
  countryUSA: 'Stati Uniti',
  countryGermany: 'Germania',
  countryJapan: 'Giappone',
  countryFrance: 'Francia',
  countryUK: 'Regno Unito',
  citationVerified: 'Verificato',
  citationUnverified: 'Non verificato',
  imageLoadFailed: 'Impossibile caricare l\\\'immagine',
  smartDocTitle: 'Assistente documenti intelligente',
  smartDocChatTitle: 'Assistente IA per documenti',
  smartDocDropPrompt: 'Trascina il file PDF qui',
  smartDocSelectFile: 'Seleziona file',
  smartDocOr: 'o',
  smartDocWelcomeTitle: 'Benvenuto nell\\\'Assistente IA per Documenti',
  smartDocWelcomeYouCan: 'Puoi:',
  smartDocUploadForAI: 'Caricare un modello per analisi IA',
  smartDocDescribeDoc: 'Descrivere i requisiti',
  smartDocLetAIDraft: 'L\\\'IA ti aiuta a redigere contratti',
  smartDocExamples: 'Esempi:',
  smartDocExampleRental: '"Redigi un contratto di locazione"',
  smartDocExampleLabor: '"Compila il contratto di lavoro"',
  smartDocInputPlaceholder: 'Descrivi le tue esigenze...',
  smartDocRemoveAttachment: 'Rimuovi allegato',
  smartDocOpenResources: 'Apri pannello risorse',
  smartDocExit: 'Esci',
  reviewStartFailed: 'Avvio revisione fallito',
  reviewFailed: 'Revisione fallita',
  reviewFoundIssues: 'Revisione completata, %{count} problemi trovati.',
  cannotReadStream: 'Impossibile leggere il flusso di risposta',
  parseEventFailed: 'Impossibile analizzare l\\\'evento',
  errorPrefix: 'Errore',
  unknownError: 'Errore sconosciuto',
  file: 'File',
  loading: 'Caricamento...',
  localFolders: 'Cartelle locali',
  selectLocalFolder: 'Seleziona cartella locale',
  reselectFolder: 'Cambia cartella',
  addToContext: 'Aggiungi alla chat',
  saveFile: 'Salva',
  renameFile: 'Rinomina',
  fileSaved: 'File salvato',
  fileRenamed: 'File rinominato in %{name}',
  browserNotSupported: 'Il browser non supporta l\\\'accesso alle cartelle locali',
  noFolderSelected: 'Seleziona una cartella locale per sfogliare i file',
  scanningFolder: 'Scansione cartella...',
  selectFileToPreview: 'Seleziona un file per l\\\'anteprima',
  aiAnalyze: 'Analisi IA',
};
